import { mount } from 'svelte'
import './index.css'
import App from './App.svelte'
import { initWidgetBridge } from './services/widgetBridge'
import { watchKeyboardInset } from './lib/keyboardInset'
import { bulletFontReady } from './ui/theme'

// Module-level (not an effect): store subscriptions must be registered exactly once.
// Under React this comment warned about StrictMode double-invoking effects; Svelte has
// no such double-invoke, but the reason to keep this at module scope is unchanged —
// the bridge wires long-lived store subscriptions that must not be torn down and
// re-established with the component tree.
initWidgetBridge()

// Same reason: one long-lived visualViewport listener, publishing the on-screen
// keyboard's height to CSS so the bottom sheets can lift clear of it.
watchKeyboardInset()

// Wait for the bullet face before the first paint. The promise chain preserves the same
// ordering without emitting top-level await, which older low-end Android System WebViews
// cannot parse even when the rest of a benchmark profile is downlevelled to ES2019.
export default bulletFontReady().then(() =>
  mount(App, { target: document.getElementById('root')! }),
)
